import Mutations from '../../odata/mutations';

export default { ...new Mutations('synonymSearchResult'), ...new Mutations('synonymSearchResults') };
